import axios from "../http";
import { handleGetRequestParams } from '../common/js/util'

class InventoryReconciliation {
  // 进出仓应收对账列表
  static getInventoryReconciliationList(options) {
    let url = '/zwy/api/cb/logistics/bill/page?'
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 进出仓应收对账详情
  static getInventoryReconciliationDetails(id) {
    const url = `/zwy/api/cb/logistics/bill/get/${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 修改进仓金额
  static postModEnterWarehouseAmount(id, data) {
    const url = `/zwy/api/cb/logistics/bill/update/imports/fee/detail/${id}`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 修改出仓金额
  static postModExitWarehouseAmount(id, data) {
    const url = `/zwy/api/cb/logistics/bill/update/exports/fee/detail/${id}`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 作废
  static postNullify(id) {
    const url = `/zwy/api/cb/logistics/bill/remove/${id}`
    return axios.post(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 导出账单
  static getExportExcel(id) {
    const url = `/zwy/api/cb/logistics/bill/download/${id}`
    return axios.get(url, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
  // 自动拆分--预览接口
  static getAutoSplitPreviewList(data) {
    const url = `/zwy/api/cb/logistics/bill/invoice/preview`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 自动拆分
  static postAutoSplit(data) {
    const url = `/zwy/api/cb/logistics/bill/auto/split`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 费用列表
  static getFeeNameList(data) {
    const url = `/zwy/api/cb/logistics/bill/order/fee/list`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 手动拆分
  static postHandMovementSplit(data) {
    const url = `/zwy/api/cb/logistics/bill/hand/split`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }

  // 编辑存储费总额
  static postModStorageAmount(data, id) {
    const url = `/zwy/api/cb/logistics/bill/update/rent/fee/detail/${id}`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 编辑记录
  static postStorageModRecordsList(id) {
    const url = `/zwy/api/cb/logistics/bill/rent/fee/detail/${id}/edit/records`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
}

export default InventoryReconciliation